/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Remove_Set_ButtonInputs */



/**
* | output |
* | --- |
* | "Remove" |
*
* @param {Tags_Manager_Remove_Set_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_remove_set_button = /** @type {((inputs?: Tags_Manager_Remove_Set_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Remove_Set_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Entfernen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалять")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("消除")
	if (locale === "ja") return /** @type {LocalizedString} */ ("取り除く")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निकालना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remover")
	return /** @type {LocalizedString} */ ("Remove")
});